import React from 'react';

type ContextValues = {
    errors: {
        [k: string]: {
            name: string;
            message: string;
        } | null;
    };
    values: {
        [k: string]: any;
    };

    handleChange?: (value: string, id: string) => void;
};

type FormProviderProps = {
    children: React.ReactNode;
    value: ContextValues;
};

const FormContext = React.createContext<ContextValues>({
    values: {},
    errors: {},
});
export default FormContext;

export function FormProvider({ children, ...props }: FormProviderProps) {
    return <FormContext.Provider value={{ ...props.value }}>{children}</FormContext.Provider>;
}
